var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPapersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33334 0.166748C0.685838 0.166748 0.166672 0.685915 0.166672 1.33341V7.16675H1.33334V1.33341H7.16667V0.166748H1.33334ZM3.66667 2.50008C3.01917 2.50008 2.50001 3.01925 2.50001 3.66675V9.50008H3.66667V3.66675H9.50001V2.50008H3.66667ZM6.00001 4.83342C5.35251 4.83342 4.83334 5.35258 4.83334 6.00008V10.6667C4.83334 11.3142 5.35251 11.8334 6.00001 11.8334H10.6667C11.3142 11.8334 11.8333 11.3142 11.8333 10.6667V6.00008C11.8333 5.35258 11.3142 4.83342 10.6667 4.83342H6.00001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPapersIcon);
export default __webpack_public_path__ + "static/media/papers-icon.26a2e3ff.svg";
export { ForwardRef as ReactComponent };